@if (viewportService.isMobile()) {
    @if (!hideBookingHubOnMobile) {
        <p-scrollpanel
            class="booking-hub-scroll-panel rounded-t-2xl"
            [style]="{ width: '100%', height: '100%' }"
            styleClass="w-full rounded-t-2xl">
            <div class="h-auto max-h-full flex flex-col justify-end">
                <fm-booking-hub class="h-full" />
            </div>
        </p-scrollpanel>
    }
} @else {
    <p-scrollpanel
        class="booking-hub-scroll-panel rounded-t-2xl"
        [style]="{ width: '100%', height: '100%' }"
        styleClass="w-full">
        <!-- spacer on top -->
        <div class="h-1 w-full"></div>

        <div class="h-auto bp908:px-1 flex flex-col bp908:gap-1 justify-end bp908:justify-start">
            @if (isWelcomeChecklistActive()) {
                <fm-new-welcome-checklist-sidebar class="w-full" />
            } @else if (isGroupMeetingsBetaEnabled()) {
                <fm-group-meetings-sidebar class="w-full" />
            } @else {
                <fm-year-in-focus-sidebar class="w-full" />
            }

            <fm-booking-hub class="h-full bp908:h-auto" />

            @if (showUpcomingSessions) {
                <fm-upcoming-session-panel class="hidden bp908:block" />
            }

            @if (selectedSessions.length > 0) {
                <div
                    class="bp908:block w-full h-auto bg-p-content-background p-4 bp908:rounded-2xl bp908:shadow-p-form-field-shadow bp908:border bp908:border-p-content-border-color">
                    <fm-selected-sessions-list
                        class="h-full"
                        [selectedSessions]="selectedSessions" />
                </div>
            }

            @if (
                (userService.currentUser | async).userId &&
                (userService.currentUser | async).group.length > 0
            ) {
                <fm-group-filter />
            }
        </div>

        <!-- spacer on bottom -->
        <div class="h-1 w-full"></div>
    </p-scrollpanel>
}
